export default "/_next/static/chunks/fonts/DAZN Oscine Regular-3d3f77a320af0c3443f4372410249944.ttf";